// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"282":"45a309b7","656":"45a309b7"}[chunkId] + ".chunk.css";
};